module.exports = __webpack_public_path__ + "img/one_reg_landpg_600.37be339e.png";